import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

export default function TermsPage() {
  return (
    <div style={{ fontFamily: "'Inter', -apple-system, sans-serif", background: "#fff", minHeight: "100vh" }}>
      <Helmet>
        <title>Terms of Service - Hub360 B2B E-Commerce Platform</title>
        <meta name="description" content="Terms of Service for Hub360 B2B wholesale e-commerce platform. Read our terms and conditions for using the Hub360 platform." />
        <link rel="canonical" href="https://ecom.skyhubs.in/terms" />
        <meta property="og:title" content="Terms of Service - Hub360" />
        <meta property="og:url" content="https://ecom.skyhubs.in/terms" />
      </Helmet>

      <div style={{ borderBottom: "1px solid #f1f5f9", padding: "16px 0" }}>
        <div style={{ maxWidth: "1100px", margin: "0 auto", padding: "0 24px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Link to="/" style={{ textDecoration: "none", display: "flex", alignItems: "center", gap: "8px" }}>
            <div style={{ width: "28px", height: "28px", background: "#4f46e5", borderRadius: "6px", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <span style={{ fontSize: "13px", fontWeight: "900", color: "#fff" }}>H</span>
            </div>
            <span style={{ fontSize: "20px", fontWeight: "800", color: "#0f172a" }}>Hub<span style={{ color: "#4f46e5" }}>360</span></span>
          </Link>
          <Link to="/" style={{ fontSize: "14px", color: "#4f46e5", textDecoration: "none", fontWeight: "600" }}>
            &larr; Back to Home
          </Link>
        </div>
      </div>

      <div style={{ maxWidth: "720px", margin: "0 auto", padding: "48px 24px 80px" }}>
        <h1 style={{ fontSize: "32px", fontWeight: "800", color: "#0f172a", marginBottom: "8px" }}>Terms of Service</h1>
        <p style={{ fontSize: "14px", color: "#94a3b8", marginBottom: "32px" }}>Last updated: January 2024</p>

        <h2 style={{ fontSize: "20px", fontWeight: "700", color: "#0f172a", marginBottom: "10px" }}>1. Acceptance of Terms</h2>
        <p style={{ fontSize: "15px", color: "#475569", lineHeight: 1.7, marginBottom: "24px" }}>
          By accessing and using the Hub360 platform ("Service"), you agree to be bound by these Terms of Service.
          If you do not agree to these terms, please do not use our Service.
        </p>

        <h2 style={{ fontSize: "20px", fontWeight: "700", color: "#0f172a", marginBottom: "10px" }}>2. Description of Service</h2>
        <p style={{ fontSize: "15px", color: "#475569", lineHeight: 1.7, marginBottom: "24px" }}>
          Hub360 provides a B2B wholesale e-commerce platform that enables businesses to manage products,
          orders, inventory, and integrates with Saral Accounting software for financial management.
        </p>

        <h2 style={{ fontSize: "20px", fontWeight: "700", color: "#0f172a", marginBottom: "10px" }}>3. User Accounts</h2>
        <p style={{ fontSize: "15px", color: "#475569", lineHeight: 1.7, marginBottom: "24px" }}>
          You are responsible for maintaining the confidentiality of your account credentials and for all
          activities that occur under your account. You must notify us immediately of any unauthorized use.
        </p>

        <h2 style={{ fontSize: "20px", fontWeight: "700", color: "#0f172a", marginBottom: "10px" }}>4. Acceptable Use</h2>
        <p style={{ fontSize: "15px", color: "#475569", lineHeight: 1.7, marginBottom: "24px" }}>
          You agree to use the Service only for lawful purposes and in accordance with these Terms.
          You shall not use the Service to transmit harmful content, interfere with other users, or
          violate any applicable laws.
        </p>

        <h2 style={{ fontSize: "20px", fontWeight: "700", color: "#0f172a", marginBottom: "10px" }}>5. Intellectual Property</h2>
        <p style={{ fontSize: "15px", color: "#475569", lineHeight: 1.7, marginBottom: "24px" }}>
          The Service and its original content, features, and functionality are owned by Skyhubs Technolabs
          and are protected by applicable intellectual property laws.
        </p>

        <h2 style={{ fontSize: "20px", fontWeight: "700", color: "#0f172a", marginBottom: "10px" }}>6. Limitation of Liability</h2>
        <p style={{ fontSize: "15px", color: "#475569", lineHeight: 1.7, marginBottom: "24px" }}>
          Hub360 shall not be liable for any indirect, incidental, special, or consequential damages
          resulting from the use or inability to use the Service.
        </p>

        <h2 style={{ fontSize: "20px", fontWeight: "700", color: "#0f172a", marginBottom: "10px" }}>7. Contact</h2>
        <p style={{ fontSize: "15px", color: "#475569", lineHeight: 1.7 }}>
          For questions about these Terms, contact us at{" "}
          <a href="mailto:info@skyhubs.in" style={{ color: "#4f46e5", textDecoration: "none" }}>info@skyhubs.in</a>.
        </p>
      </div>
    </div>
  );
}
